import React, { useContext } from 'react'
/// React router dom
import { Routes, Route, Outlet, Navigate } from 'react-router-dom'
import { connect } from 'react-redux';
/// Css
import './index.css'
import './chart.css'
import './step.css'

/// Layout
import Nav from './layouts/nav'
import Footer from './layouts/Footer'

/// Streams
import StreamDashboard from "./components/Streams/StreamDashboard";
import StreamList from "./components/Streams/StreamList";
import CreateStream from "./components/Streams/CreateStream";
import StreamDetail from "./components/Streams/StreamDetail";

/// VOD Management
import MediaDirectoryManager from "./components/VOD/MediaDirectoryManager";
import VODUploader from "./components/VOD/VODUploader";
import PlaylistManagement from "./components/VOD/PlaylistManagement";
import ScheduleManagement from "./components/VOD/ScheduleManagement";

/// Admin Pages

import UserManagement from "./pages/admin/UserManagement";
import RoleManagement from "./pages/admin/RoleManagement";
import GeneralSettings from "./pages/admin/GeneralSettings";

/// Auth
import StreamLogin from "./pages/StreamLogin";
import ChangePassword from "./components/Auth/ChangePassword";


/// Error Pages
import Error403 from './pages/Error403'
import Error404 from './pages/Error404'

import { ThemeContext } from "../context/ThemeContext";
//Scroll To Top
import ScrollToTop from './layouts/ScrollToTop';

// Protected Route component for admin-only routes
const ProtectedRoute = ({ children, user, requiredRole = 'admin' }) => {
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  if (requiredRole === 'admin' && user.role !== 'admin') {
    return <Navigate to="/stream-dashboard" replace />;
  }
  
  return children;
};

const Markup = ({ user }) => {
  
  const allroutes = [
    /// Main Routes (accessible to all authenticated users)
    { url: "", component: <StreamDashboard /> },
    { url: "stream-dashboard", component: <StreamDashboard /> },
    { url: "streams", component: <StreamList /> },
    { url: "create-stream", component: <CreateStream /> },
    { url: "streams/:id", component: <StreamDetail /> },
    { url: "change-password", component: <ChangePassword /> },

    /// VOD Management Routes
    { url: "vod/directories", component: <MediaDirectoryManager /> },
    { url: "vod/uploader", component: <VODUploader /> },
    { url: "vod/playlists", component: <PlaylistManagement /> },
    { url: "vod/schedules", component: <ScheduleManagement /> },

    /// Admin Routes (admin only)


    { 
      url: "admin/users", 
      component: <UserManagement />,
      adminOnly: true 
    },
    { 
      url: "admin/roles", 
      component: <RoleManagement />,
      adminOnly: true 
    },
    { 
      url: "admin/settings", 
      component: <GeneralSettings />,
      adminOnly: true 
    },
  ]

  return (
       <>          
          <Routes>
            <Route path='/login' element={<StreamLogin />} />
            <Route path='/page-error-403' element={<Error403/>} />
            <Route path='/page-error-404' element={<Error404/>} />
            <Route path='*' element={<Error404/>} />
            
            <Route element={<MainLayout />} > 
                {allroutes.map((data, i) => (
                  <Route
                    key={i}
                    exact
                    path={`${data.url}`}
                    element={
                      data.adminOnly ? (
                        <ProtectedRoute user={user} requiredRole="admin">
                          {data.component}
                        </ProtectedRoute>
                      ) : (
                        data.component
                      )
                    }
                  />
                ))}
            </Route>           
          </Routes>      
         <ScrollToTop />
       </>
  )
}

function MainLayout(){  
  const { menuToggle, sidebariconHover } = useContext(ThemeContext);
  return (
    <>
      <div id="main-wrapper" className={`show ${sidebariconHover ? "iconhover-toggle": ""} ${ menuToggle ? "menu-toggle" : ""}`}>  
        <Nav />
        <div className="content-body" style={{ minHeight: window.screen.height - 45 }}>
            <div className="container-fluid">
              <Outlet />                
            </div>
        </div>
        <Footer />
      </div>
    </>
  )
};

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
  };
};

export default connect(mapStateToProps)(Markup);
